import { usePushNotifications } from '../hooks/usePushNotifications'

/**
 * Mounts push registration + notification deep linking (see
 * usePushNotifications). Renders nothing. Mounted in Router so it sits under
 * both IonReactRouter and CurrentUserProvider; self-guards on native platform,
 * logged-in operator and the `notification.push` flag.
 */
export const PushNotificationsListener = () => {
  usePushNotifications()
  return null
}
